import { ContentBlock } from "@/components/ContentBlock/ContentBlock";
import FeesAndExpensesTable from "@/components/FeesAndExpenses/FeesAndExpensesTable";
import type { FundDetailLayoutComponentProps } from "@/types/fundDetailLayout";

export const FxDefinitionListPanel = ({ dashboard, flex }: FundDetailLayoutComponentProps) => {
	const { fxDefinitionListPanel: props } = dashboard;
	if (!props) {
		return null;
	}

	const { id } = props;

	return (
		<ContentBlock id="fxDefinitionListPanel" data-testid="FxDefinitionListPanel" flex={flex} minW="calc(50% - 10px)" tabIndex={-1}>
			<FeesAndExpensesTable title={props.title as string} items={props.categoryItems} disclaimer={props.disclaimer} />
		</ContentBlock>
	);
};
